// extracted by mini-css-extract-plugin
export default {"chip":"BlackoutReasonChip_chip__lKEF5","label":"BlackoutReasonChip_label__rvqzF","full":"BlackoutReasonChip_full__M-kYv","partial":"BlackoutReasonChip_partial__PgfQa"};